import Vue from "vue";
import Router from "vue-router";

const pageTitle = 'ACCRM';
Vue.use(Router);
export default new Router({
    //mode: "hash",
    mode: "history",
    routes: [
        //首页
        {
            path: "/",
            // redirect:'/section1'
            name: "index",
            component: () => import('@/page/Index.vue'),
            meta: {
                template:1,
                title: pageTitle,
                allowBack: true,
                lesson:'home'
            }
        },
        //---第一课时
        {
            path: "/section1",
            name: "section1",
            component: () => import('@/page/section1/s1_index.vue'),
            meta: {
                template:2,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in chronic kidney disease (CKD) associated with type 2 diabetes",
                lesson:'lesson1',
                percent: 0,
                notice: 'CKD, chronic kidney disease.'
            },
        },
        {
            path: "/section1/1-1",
            name: "section1-1",
            component: () => import('@/page/section1/s1-1.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.15,
                lesson:'lesson1',
                section:'section1'
            }
        },
        {
            path: "/section1/1-2",
            name: "section1-2",
            component: () => import('@/page/section1/s1-2.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.15,
                lesson:'lesson1',
                section:'section2'
            }
        },
        {
            path: "/section1/1-3",
            name: "section1-3",
            component: () => import('@/page/section1/s1-3.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.15,
                lesson:'lesson1',
                section:'section3'
            }
        },
        {
            path: "/section1/1-4",
            name: "section1-4",
            component: () => import('@/page/section1/s1-4.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.15,
                lesson:'lesson1',
                section:'section4'
            }
        },
        {
            path: "/section1/1-5",
            name: "section1-5",
            component: () => import('@/page/section1/s1-5.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.25,
                lesson:'lesson1',
                section:'section5'
            }
        },
        {
            path: "/section1/1-6",
            name: "section1-6",
            component: () => import('@/page/section1/s1-6.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to finerenone",
                percent:0.15,
                lesson:'lesson1',
                section:'section6'
            }
        },

//---第2课时
        {
            path: "/section2",
            name: "section2",
            component: () => import('@/page/section2/s2_index.vue'),
            meta: {
                template:2,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health monitoring in T2D",
                lesson:'lesson2',
                percent: 0,
                notice: 'T2D, type 2 diabetes.'
            }
        },
        {
            path: "/section2/2-1",
            name: "section2-1",
            component: () => import('@/page/section2/s2-1.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health <br/>monitoring in T2D",
                percent:0.2,
                lesson:'lesson2',
                section:'section1'
            }
        },
        {
            path: "/section2/2-2",
            name: "section2-2",
            component: () => import('@/page/section2/s2-2.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health <br/>monitoring in T2D",
                percent:0.2,
                lesson:'lesson2',
                section:'section2'
            }
        },
        {
            path: "/section2/2-3",
            name: "section2-3",
            component: () => import('@/page/section2/s2-3.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health <br/>monitoring in T2D",
                percent:0.2,
                lesson:'lesson2',
                section:'section3'
            }
        },
        {
            path: "/section2/2-4",
            name: "section2-4",
            component: () => import('@/page/section2/s2-4.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health <br/>monitoring in T2D",
                percent:0.2,
                lesson:'lesson2',
                section:'section4'
            }
        },
        {
            path: "/section2/2-5",
            name: "section2-5",
            component: () => import('@/page/section2/s2-5.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"The role for kidney health <br/>monitoring in T2D",
                percent:0.2,
                lesson:'lesson2',
                section:'section5'
            }
        },

//---第3课时
        {
            path: "/section3",
            name: "section3",
            component: () => import('@/page/section3/s3_index.vue'),
            meta: {
                template:2,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in reducing kidney progression and CV risks in CKD with T2D",
                lesson:'lesson3',
                notice: 'CKD, chronic kidney disease; CV, cardiovascular; MRA, mineralocorticoid receptor antagonist; T2D, type 2 diabetes.'
            }
        },
        {
            path: "/section3/3-1",
            name: "section3-1",
            component: () => import('@/page/section3/s3-1.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section1'
            }
        },
        {
            path: "/section3/3-2",
            name: "section3-2",
            component: () => import('@/page/section3/s3-2.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section2'
            }
        },
        {
            path: "/section3/3-3",
            name: "section3-3",
            component: () => import('@/page/section3/s3-3.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.08,
                lesson:'lesson3',
                section:'section3'
            }
        },
        {
            path: "/section3/3-4",
            name: "section3-4",
            component: () => import('@/page/section3/s3-4.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section4'
            }
        },
        {
            path: "/section3/3-5",
            name: "section3-5",
            component: () => import('@/page/section3/s3-5.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section5'
            }
        },
        {
            path: "/section3/3-6",
            name: "section3-6",
            component: () => import('@/page/section3/s3-6.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section6'
            }
        },
        {
            path: "/section3/3-7",
            name: "section3-7",
            component: () => import('@/page/section3/s3-7.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.08,
                lesson:'lesson3',
                section:'section7'
            }
        },
        {
            path: "/section3/3-8",
            name: "section3-8",
            component: () => import('@/page/section3/s3-8.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.08,
                lesson:'lesson3',
                section:'section8'
            }
        },
        {
            path: "/section3/3-9",
            name: "section3-9",
            component: () => import('@/page/section3/s3-9.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section9'
            }
        },
        {
            path: "/section3/3-10",
            name: "section3-10",
            component: () => import('@/page/section3/s3-10.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section10'
            }
        },
        {
            path: "/section3/3-11",
            name: "section3-11",
            component: () => import('@/page/section3/s3-11.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section11'
            }
        },
        {
            path: "/section3/3-12",
            name: "section3-12",
            component: () => import('@/page/section3/s3-12.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.08,
                lesson:'lesson3',
                section:'section12'
            }
        },
        {
            path: "/section3/3-13",
            name: "section3-13",
            component: () => import('@/page/section3/s3-13.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Clinical evidence for nonsteroidal MRAs (finerenone) in treating CKD associated with T2D",
                percent:0.04,
                lesson:'lesson3',
                section:'section13'
            }
        },

        //---第4课时
        {
            path: "/section4",
            name: "section4",
            component: () => import('@/page/section4/s4_index.vue'),
            meta: {
                template:2,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD associated with T2D",
                lesson:'lesson4',
                notice: "CKD, chronic kidney disease; MRA, mineralocorticoid receptor antagonist; <br/>T2D, type 2 diabetes."
            }
        },
        {
            path: "/section4/4-1",
            name: "section4-1",
            component: () => import('@/page/section4/s4-1.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section1'
            }
        },
        {
            path: "/section4/4-2",
            name: "section4-2",
            component: () => import('@/page/section4/s4-2.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section2'
            }
        },
        {
            path: "/section4/4-3",
            name: "section4-3",
            component: () => import('@/page/section4/s4-3.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section3'
            }
        },
        {
            path: "/section4/4-4",
            name: "section4-4",
            component: () => import('@/page/section4/s4-4.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section4'
            }
        },
        {
            path: "/section4/4-5",
            name: "section4-5",
            component: () => import('@/page/section4/s4-5.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section5'
            }
        },
        {
            path: "/section4/4-6",
            name: "section4-6",
            component: () => import('@/page/section4/s4-6.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section6'
            }
        },
        {
            path: "/section4/4-7",
            name: "section4-7",
            component: () => import('@/page/section4/s4-7.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.1,
                lesson:'lesson4',
                section:'section7'
            }
        },
        {
            path: "/section4/4-8",
            name: "section4-8",
            component: () => import('@/page/section4/s4-8.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.15,
                lesson:'lesson4',
                section:'section8'
            }
        },
        {
            path: "/section4/4-9",
            name: "section4-9",
            component: () => import('@/page/section4/s4-9.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Initiating nonsteroidal MRAs (finerenone) in clinical practice as part of a comprehensive approach to CKD",
                percent:0.15,
                lesson:'lesson4',
                section:'section9'
            }
        },

        //---第5课时
        {
            path: "/section5",
            name: "section5",
            component: () => import('@/page/section5/s5_index.vue'),
            meta: {
                template:2,
                title: pageTitle,
                allowBack: true,
                sub_header:"Post-activity quiz",
                lesson:'lesson5',
            }
        },
        {
            path: "/section5/5-1",
            name: "section5-1",
            component: () => import('@/page/section5/s5-1.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0.2,
                lesson:'lesson5',
                section:'section1'
            }
        },
        {
            path: "/section5/5-2",
            name: "section5-2",
            component: () => import('@/page/section5/s5-2.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0.2,
                lesson:'lesson5',
                section:'section2'
            }
        },
        {
            path: "/section5/5-3",
            name: "section5-3",
            component: () => import('@/page/section5/s5-3.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0.2,
                lesson:'lesson5',
                section:'section3'
            }
        },
        {
            path: "/section5/5-4",
            name: "section5-4",
            component: () => import('@/page/section5/s5-4.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0.2,
                lesson:'lesson5',
                section:'section4'
            }
        },
        {
            path: "/section5/5-5",
            name: "section5-5",
            component: () => import('@/page/section5/s5-5.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0.2,
                lesson:'lesson5',
                section:'section5'
            }
        },
        {
            path: "/section5/5-6",
            name: "section5-6",
            component: () => import('@/page/section5/s5-6.vue'),
            meta: {
                template:3,
                title: pageTitle,
                allowBack: true,
                sub_header:"Heart and kidney protection in type 2 diabetes with CKD: An introduction to finerenone",
                percent:0,
                lesson:'lesson5',
                section:'section6'
            }
        }
    ]
});
